module.exports = __webpack_public_path__ + "03bf6d762342db77064e2e0120cbc8e8.MP3";